import { render, staticRenderFns } from "./RequisitionList.vue?vue&type=template&id=3fac3022&scoped=true&"
import script from "./RequisitionList.vue?vue&type=script&lang=js&"
export * from "./RequisitionList.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionList.vue?vue&type=style&index=0&id=3fac3022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac3022",
  null
  
)

export default component.exports